// extracted by mini-css-extract-plugin
export default {"btn":"Login_btn__yzxnQ","inputLogin":"Login_inputLogin__LSl7O","button":"Login_button__2nmfG"};